<div class="page-content fade-in-up">
    <div class="row">

        <div class="col-lg-12 col-md-12">

            <div class="ibox">
                <div class="ibox-head">
                    <div class="ibox-title">File </div>
                </div>

                <div class="ibox-body">
                    <ul class="nav nav-tabs tabs-line">
                        <li class="nav-item">
                            <a class="nav-link {{activeTab=='all' ?'active':'deactive'}}"
                                (click)="getAllModuleWork('all')"><i class="fa fa-line-chart"></i>
                                All File List</a>
                        </li>
                        <!-- <li class="nav-item" >
                            <a class="nav-link {{activeTab=='account' ?'active':'deactive'}}" (click)="getAllAccountWork('account')"><i class="fa fa-line-chart"></i>
                                Account File List</a>
                        </li> -->
                        <!-- <li class="nav-item">
                            <a class="nav-link {{activeTab=='computer' ?'active':'deactive'}}"
                                (click)="getAllComputerWork('computer')"><i class="fa fa-line-chart"></i>
                                Computer File List</a>
                        </li> -->
                        <!-- <li class="nav-item">
                            <a class="nav-link {{activeTab=='store' ?'active':'deactive'}}"
                                (click)="getAllStoreWork('store')"><i class="fa fa-line-chart"></i>
                                Store File List</a>
                        </li> -->
                        <li class="nav-item" *ngIf="allWork_flage">
                            <a class="nav-link {{activeTab=='unAuth' ?'active':'deactive'}}"
                                (click)="allWorkList('unAuth')"><i class="fa fa-line-chart"></i>
                                All File List</a>
                        </li>
                        <li class="nav-item" *ngIf="create_flag">
                            <a class="nav-link {{create_flag?'active':'deactive'}}" (click)="refresh()"><i
                                    class="fa fa-plus-circle"></i>
                                Create File </a>
                        </li>
                        <li class="nav-item" *ngIf="update_flag">
                            <a class="nav-link {{update_flag?'active':'deactive'}}" (click)="refresh()"><i
                                    class="ti-settings"></i>
                                Update File</a>
                        </li>
                        <li class="nav-item" *ngIf="view_details">
                            <a class="nav-link {{view_details?'active':'deactive'}}"><i class="ti-settings"></i>
                                File Info</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div id="tab-1" [hidden]="!all_list_flag">
                            <br>

                            <div class="row">
                                <div class="col-4">
                                    <!-- <mat-form-field>
                                        <mat-label>Filter</mat-label>
                                        <input matInput (keyup)="tapp($event)" placeholder="Ex. Mia" #input>
                                      </mat-form-field> -->
                                    <mat-form-field style="margin-left: 2%">
                                        <input matInput (keyup)="applyFilter($event)" placeholder="Filter">
                                    </mat-form-field>
                                </div>
                                <div class="col-4 text-center">
                                </div>
                                <div class="col-4 text-right">
                                    <button type="button" class="btn btn-primary" href="#tab-4" data-toggle="tab"
                                        (click)="allWorkList('unAuth')">See All File
                                    </button> &nbsp;&nbsp;&nbsp;
                                    <button type="button" class="btn btn-primary" href="#tab-2" data-toggle="tab"
                                        (click)="createNew()">Create New
                                    </button>
                                </div>
                            </div>

                            <!-- <div class=" example-container"> -->
                            <!-- <table mat-table [dataSource]="datasource" matSort #sortCol1="matSort">
                                    <ng-container matColumnDef="work_id">
                                        <th mat-header-cell *matHeaderCellDef class="left" mat-sort-header>ID

                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element; let i = index; "
                                            class="right">
                                            {{ element.work_id }}</td>
                                    </ng-container>


                                    <ng-container matColumnDef="work_no">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header> File
                                            Number

                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            {{ element.work_order_no }} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="work_desc">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header> File
                                            Description

                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            {{ element.work_desc }} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="party_le_id">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header> Firm name

                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            {{ element.party_legal_name }} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="start_dt">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header> Work Order
                                            Start
                                            Date

                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            {{ element.work_start_dt | date: 'dd/MM/yyyy'}} </td>
                                    </ng-container>
                                   
                                    <ng-container matColumnDef="amt">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header> File
                                            Amount
                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            {{ element.work_order_amt }} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="status">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header> Status
                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            {{ element.status }} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="le_id">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header> Assigned To
                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            {{ AllPartyObj[element.le_id]}} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="action" style="width: 15%;">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Action</th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">

                                            <button type="button" class="btn btn-primary"
                                                *ngIf="element.status == 'ACTIVE'" (click)="open_update(element)"
                                                href="#tab-3" data-toggle="tab">Update</button>

                                            <button type="button" class="btn btn-info"
                                                *ngIf="element.status == 'APPROVED' && is_loggedIn_role_is_FAO"
                                                (click)="openAssignment(element)">Assign To</button>

                                            <button type="button" class="btn btn-success" style="white-space: nowrap;"
                                                *ngIf="apprflag &&element.status == 'ACTIVE'"
                                                (click)="Appr(element)">Forward
                                                File</button>
                                            <button type="button" class="btn btn-info"
                                                *ngIf="element.status == 'UNDERAPPROVAL' || element.status == 'APPROVED' || element.status == 'REJECTED'"
                                                (click)="viewStatus(element)">Status</button>
                                            <button type="button" class="btn btn-danger"
                                                *ngIf="element.status == 'ACTIVE'"
                                                (click)="delete(element)">Delete</button>


                                         
                                            <button type="button" class="btn btn-primary"
                                                (mouseenter)="targetMenuTrigger =createPlanmenuTrigger; mouseEnter(createPlanmenuTrigger)"
                                                (mouseleave)="mouseLeave(createPlanmenuTrigger)"
                                                style="white-space: nowrap;background: #7C2AC0 !important;color: white;"
                                                #createPlanmenuTrigger="matMenuTrigger"
                                                [matMenuTriggerFor]="createPlan">More</button>

                                            <mat-menu #createPlan="matMenu" [hasBackdrop]="false"
                                                [overlapTrigger]="false">
                                                <div (mouseenter)="mouseEnter(targetMenuTrigger)"
                                                    (mouseleave)="mouseLeave(targetMenuTrigger)">
                                                    <button mat-menu-item (click)="viewDeatils(element,0)">View Work
                                                        Details</button>
                                                    <button mat-menu-item
                                                        (click)="viewDoc(element,'work_order_doc')">Notesheet
                                                        Document</button>

                                                    <button mat-menu-item
                                                        (click)="viewDoc(element,'work_order_approval_doc')">Reference
                                                        Document</button>
                                                </div>
                                            </mat-menu>
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                                    </tr>
                                </table> -->


                            <div class=" example-container">
                                <table mat-table [dataSource]="datasource" multiTemplateDataRows
                                    class="mat-elevation-z8">
                                    <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                                        <th mat-header-cell *matHeaderCellDef style="text-align: center;">
                                            {{displayedColumnsObj[column]}} </th>
                                        <td mat-cell *matCellDef="let element" style="text-align: center;">
                                            <ng-container *ngIf="column === 'action'; else normalCell">
                                                <button type="button" class="btn btn-primary"
                                                    *ngIf="element.status == 'ACTIVE'" (click)="open_update(element)"
                                                    href="#tab-3" data-toggle="tab">Update</button>

                                                <button type="button" class="btn btn-info"
                                                    *ngIf="element.status == 'APPROVED' && is_loggedIn_role_is_FAO"
                                                    (click)="openAssignment(element)">Assign To</button>

                                                <button type="button" class="btn btn-success"
                                                    *ngIf="apprflag &&element.status == 'ACTIVE'"
                                                    (click)="Appr(element)">Forward File</button>
                                                <button type="button" class="btn btn-info"
                                                    *ngIf="element.status == 'UNDERAPPROVAL' || element.status == 'APPROVED' || element.status == 'REJECTED'"
                                                    (click)="viewStatus(element)">Status</button>
                                                <button type="button" class="btn btn-danger"
                                                    *ngIf="element.status == 'ACTIVE'"
                                                    (click)="delete(element)">Delete</button>
                                                <!-- <button type="button" class="btn btn-primary"
                                                    (mouseenter)="targetMenuTrigger =createPlanmenuTrigger; mouseEnter(createPlanmenuTrigger)"
                                                    (mouseleave)="mouseLeave(createPlanmenuTrigger)"
                                                    style="white-space: nowrap;background: #7C2AC0 !important;color: white;"
                                                    #createPlanmenuTrigger="matMenuTrigger"
                                                    [matMenuTriggerFor]="createPlan">More</button>

                                                <mat-menu #createPlan="matMenu" [hasBackdrop]="false"
                                                    [overlapTrigger]="false">
                                                    <div (mouseenter)="mouseEnter(targetMenuTrigger)"
                                                        (mouseleave)="mouseLeave(targetMenuTrigger)">
                                                        <button mat-menu-item (click)="viewDeatils(element,0)">View Work
                                                            Details</button>
                                                        <button mat-menu-item
                                                            (click)="viewDoc(element,'work_order_doc')">Notesheet
                                                            Document</button>

                                                        <button mat-menu-item
                                                            (click)="viewDoc(element,'work_order_approval_doc')">Reference
                                                            Document</button>
                                                    </div>
                                                </mat-menu> -->
                                                <button class="btn btn-success"
                                                    [matMenuTriggerFor]="exportToggle">More</button>
                                                <mat-menu #exportToggle="matMenu">

                                                    <button mat-menu-item (click)="viewDeatils(element,0)">View Work
                                                        Details</button>
                                                    <button mat-menu-item
                                                        (click)="viewDoc(element,'work_order_doc')">Notesheet
                                                        Document</button>

                                                    <button mat-menu-item
                                                        (click)="viewDoc(element,'work_order_approval_doc')">Reference
                                                        Document</button>
                                                </mat-menu>
                                            </ng-container>
                                            <ng-template #normalCell>
                                                {{ element[column] }}
                                            </ng-template>
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"> </tr>
                                </table>

                                <mat-paginator [pageSizeOptions]="[10, 20,50,100]" showFirstLastButtons>
                                </mat-paginator>

                            </div>
                            <!-- <mat-paginator [pageSizeOptions]="[10, 20,50,100]" showFirstLastButtons>
                                </mat-paginator>

                            </div> -->
                        </div>
                        <div id="tab-2" [hidden]="!create_flag">
                            <form name="form" (ngSubmit)="f.form.valid && submit()" #f="ngForm" novalidate>
                                <br>
                                <div class="col-12 text-right">
                                    <button type="button" class="btn btn-primary" type="button"
                                        (click)="listfunc()">Back to
                                        list</button>
                                </div>
                                <br>
                                <br>
                                <div class="row">
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-2 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            Firm Info:
                                        </h5>
                                    </div>
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">

                                    <div class="col-3">
                                        <h6 style="margin-left:2%">Select Firm :<span style="color: red;">*</span></h6>
                                    </div>
                                    <div class="col-3">
                                        <ng-select [items]="all_party" bindLabel="org_name" bindValue="le_id"
                                            [multiple]="false" placeholder="Select Firm"
                                            [(ngModel)]="obj['party_le_id']" [selectableGroup]="true"
                                            [selectableGroupAsModel]="false" [closeOnSelect]="true"
                                            (change)="setPartyDetails()" name="party_id" #party_id="ngModel" required>
                                        </ng-select>
                                        <!---------------- validation start-----------------------------  -->

                                        <!-- border color green -->
                                        <div [class.border_green]="party_id.dirty && party_id.valid">
                                        </div>

                                        <!-- error handling  -->
                                        <div *ngIf="f.submitted && party_id.invalid" class="error-message">
                                            <div *ngIf="party_id.errors?.['required']">Please select firm
                                            </div>
                                        </div>

                                        <!---------------- validation end-----------------------------  -->

                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm GSTIN :<span style="color: red;">*</span></h6>
                                    </div>
                                    <div class="col-3">
                                        <input type="text" class="form-control" [(ngModel)]="obj['party_gstin_no']"
                                            name="party_gst" disabled>
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm Email :<span style="color: red;">*</span></h6>
                                    </div>
                                    <div class="col-3">
                                        <input type="text" class="form-control" [(ngModel)]="obj['party_email']"
                                            name="party_email" disabled>

                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm Mobile Number :<span
                                                style="color: red;">*</span></h6>
                                    </div>
                                    <div class="col-3">
                                        <input type="number" class="form-control" [(ngModel)]="obj['party_phone_no']"
                                            name="party_mobile" disabled>
                                    </div>
                                </div>
                                <br>
                                <br>
                                <div class="row">
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-2 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            File Info:
                                        </h5>
                                    </div>
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">File Number :<span style="color: red;">*</span></h6>
                                    </div>
                                    <div class="col-3">
                                        <input type="text" placeholder="Enter file number"
                                            [(ngModel)]="obj['work_order_no']" class="form-control"
                                            name="work_order_num" #work_order_num="ngModel" required>
                                        <!---------------- validation start-----------------------------  -->
                                        <!-- border color green -->
                                        <div [class.border_green]="work_order_num.dirty && work_order_num.valid">
                                        </div>

                                        <!-- error handling  -->
                                        <div *ngIf="f.submitted && work_order_num.invalid" class="error-message">
                                            <div *ngIf="work_order_num.errors?.['required']">Please enter file number
                                            </div>
                                        </div>
                                        <!---------------- validation end-----------------------------  -->
                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">File Description :<span style="color: red;">*</span>
                                        </h6>
                                    </div>
                                    <div class="col-3">
                                        <textarea style="width: 100%; height: 80px;" id="re" name="re"
                                            class="form-control" placeholder="Enter file description"
                                            [(ngModel)]="obj['work_desc']" name="desc" #desc="ngModel" required>
                                        </textarea>


                                        <!---------------- validation start-----------------------------  -->


                                        <!-- border color green -->
                                        <div [class.border_green]="desc.dirty && desc.valid">
                                        </div>

                                        <!-- error handling  -->
                                        <div *ngIf="f.submitted && desc.invalid" class="error-message">
                                            <div *ngIf="desc.errors?.['required']">Please enter file description</div>
                                        </div>

                                        <!---------------- validation end-----------------------------  -->


                                    </div>
                                </div>

                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Work Order Start Date :<span
                                                style="color: red;">*</span>
                                        </h6>
                                    </div>
                                    <div class="col-3">
                                        <input type="date" [(ngModel)]="obj['work_start_dt']" class="form-control"
                                            name="work_start" #work_start="ngModel" required>

                                        <!---------------- validation start-----------------------------  -->

                                        <!-- border color green -->
                                        <div [class.border_green]="work_start.dirty && work_start.valid">
                                        </div>

                                        <!-- error handling  -->
                                        <div *ngIf="f.submitted && work_start.invalid" class="error-message">
                                            <div *ngIf="work_start.errors?.['required']">Please enter work start date
                                            </div>
                                        </div>

                                        <!---------------- validation end-----------------------------  -->
                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Work Order End Date :</h6>
                                    </div>
                                    <div class="col-3">
                                        <input type="date" [(ngModel)]="obj['work_end_dt']" class="form-control"
                                            (change)="checkDate()" name="work_end" #work_end="ngModel"
                                            [min]="obj['work_start_dt']">

                                        <div [class.border_green]="work_end.dirty && work_end.valid">
                                        </div>

                                        <div *ngIf="f.submitted && work_end.invalid && work_start.value >= work_end.value"
                                            class="error-message">
                                            End date can't be before or the same as the start date.
                                        </div>
                                        <!-- <div *ngIf="f.submitted && work_end.invalid" class="error-message">
                                            <div *ngIf="work_end.errors?.['required']">Please enter work end date </div>
                                        </div> -->


                                    </div>


                                </div>
                                <br>

                                <div class="row">
                                    <div class="col-3">

                                        <h6 style="margin-left:2%">File Amount (&#8377;):<span
                                                style="color: red;">*</span></h6>

                                    </div>
                                    <div class="col-3">
                                        <input type="text" class="form-control" [(ngModel)]="obj['work_order_amt']"
                                            class="form-control" placeholder="Enter file amount"
                                            oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                                            name="work_order_am" #work_order_am="ngModel" required>

                                        <!---------------- validation start-----------------------------  -->

                                        <!-- border color green -->
                                        <div [class.border_green]="work_order_am.dirty && work_order_am.valid">
                                        </div>

                                        <div *ngIf="work_order_am.valid && work_order_am.value <= 0 "
                                            class="error-message">
                                            Please Amount Should Be Greater Than Zero
                                        </div>

                                        <div *ngIf="f.submitted && work_order_am.invalid" class="error-message">
                                            <div *ngIf="work_order_am.errors?.['required']">Please enter file amount
                                            </div>
                                        </div>

                                        <!---------------- validation end-----------------------------  -->
                                    </div>
                                </div>


                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Upload Notesheet :<span style="color: red;">*</span>
                                        </h6>
                                    </div>
                                    <div class="col-3">
                                        <input type="file" accept="application/pdf" class="form-control" name="pdf_1"
                                            #pdf1="ngModel" ngModel (change)="onChange($event,'WorkOrder_PDF1')"
                                            required>

                                        <!---------------- validation start-----------------------------  -->

                                        <!-- border color green -->
                                        <div [class.border_green]="pdf1.dirty && pdf1.valid">
                                        </div>

                                        <!-- error handling  -->
                                        <div *ngIf="f.submitted && pdf1.invalid" class="error-message">
                                            <div *ngIf="pdf1.errors?.['required']">Please Upload Notesheet
                                            </div>
                                        </div>

                                        <!---------------- validation end-----------------------------  -->
                                    </div>


                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Upload Reference:<span style="color: red;">*</span>
                                        </h6>
                                    </div>
                                    <div class="col-3">
                                        <input type="file" accept="application/pdf" class="form-control" name="pdf_2"
                                            #pdf2="ngModel" ngModel (change)="onChange($event,'WorkOrder_PDF2')"
                                            required>

                                        <!---------------- validation start-----------------------------  -->

                                        <!-- border color green -->
                                        <div [class.border_green]="pdf2.dirty && pdf2.valid">
                                        </div>

                                        <!-- error handling  -->
                                        <div *ngIf="f.submitted && pdf2.invalid" class="error-message">
                                            <div *ngIf="pdf2.errors?.['required']">Please Upload Reference
                                            </div>
                                        </div>

                                        <!---------------- validation end-----------------------------  -->
                                    </div>
                                </div>
                                <div class="row">

                                    <div style="display: contents;"
                                        *ngFor="let item of additional_document;let i = index">
                                        <div class="col-3 mt-3">
                                            <h6 style="margin-left:2%">Additional Document:</h6>
                                        </div>
                                        <div class="col-3 mt-3 d-flex">
                                            <input type="file" accept="application/pdf" class="form-control"
                                                (change)="onChangeAdditionalDoc($event,'Additional_Doc',i)">
                                            <b class="d-flex ml-1">
                                                <i class="fa fa-plus text-success plus-icon-inside-style"
                                                    aria-hidden="true" (click)="addAdditionalDoc()"
                                                    *ngIf="i == additional_document.length-1"></i> &nbsp;&nbsp;

                                                <i class="fa fa-trash trash-icon-style" aria-hidden="true"
                                                    (click)="removeAdditionalDoc(i)"
                                                    *ngIf="additional_document.length > 1 || i>1"></i>
                                            </b>

                                        </div>
                                        <br>
                                    </div>

                                </div>
                                <!-- <br>
                                <div class="row">

                                    <div class="col-3">
                                        <h6 style="margin-left:2%">File  Amount :</h6>
                                    </div>
                                    <div class="col-3">

                                        <input type="text" class="form-control" [(ngModel)]="obj['work_order_amt']"
                                            class="form-control" placeholder="Enter file amount"
                                            oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                                            name="work_order_am" #work_order_am="ngModel" required>

                                        <div *ngIf="work_order_am.value > 0 " [class.border_green]="work_order_am.dirty && work_order_am.valid">
                                        </div>
                                        <div *ngIf="work_order_am.value <= 0 " [class.border_red]="work_order_am.dirty && work_order_am.valid">
                                        </div>
                                        <div *ngIf="work_order_am.value <= 0 " class="error-message">
                                            Please Amount Should Be Greater Than Zero
                                        </div>
                                        <div *ngIf="f.submitted && work_order_am.invalid" class="error-message">
                                            <div *ngIf="work_order_am.errors?.['required']">Please enter file amount
                                            </div>
                                        </div>


                                    </div>

                                </div> -->


                                <br>
                                <br>

                                <div class="row">
                                    <div class="col-4">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-4 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            Budget-Project-Product-Activity Info:
                                        </h5>
                                    </div>
                                    <div class="col-4">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3"></div>
                                </div>
                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%">Select Budget:<span style="color: red;">*</span>
                                        </h6>
                                    </div>
                                    <div class="col-3">
                                        {{budDesc[obj['bud_cd']]}}
                                        <div *ngIf="f.submitted && !budDesc[obj['bud_cd']]" class="error-message">
                                            Please select budget hierarchy </div>

                                    </div>
                                    <div class="col-1">
                                        <button type="button" class="btn btn-primary" type="button"
                                            (click)="selectCreate('budget')">Select</button>
                                    </div>
                                </div>
                                <br>

                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Select Project:<span style="color: red;">*</span>
                                        </h6>
                                    </div>
                                    <div class="col-3">
                                        {{projectObj[obj['proj_cd']]}}
                                        <div *ngIf="f.submitted && !projectObj[obj['proj_cd']]" class="error-message">
                                            Please select project hierarchy </div>

                                    </div>
                                    <div class="col-1">
                                        <button type="button" class="btn btn-primary" type="button"
                                            (click)="selectCreate('project')">Select</button>
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Select Product:<span style="color: red;">*</span>
                                        </h6>
                                    </div>
                                    <div class="col-3">
                                        {{productObj[obj['prod_cd']]}}
                                        <div *ngIf="f.submitted && !productObj[obj['prod_cd']]" class="error-message">
                                            Please select product hierarchy </div>

                                    </div>
                                    <div class="col-1">
                                        <button type="button" class="btn btn-primary" type="button"
                                            (click)="selectCreate('product')">Select</button>
                                    </div>
                                </div>

                                <br>

                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Select Activity:<span style="color: red;">*</span>
                                        </h6>
                                    </div>
                                    <div class="col-3">
                                        {{activityObj[obj['act_cd']]}}
                                        <div *ngIf="f.submitted && !activityObj[obj['act_cd']]" class="error-message">
                                            Please select activity hierarchy </div>

                                    </div>
                                    <div class="col-1">
                                        <button type="button" class="btn btn-primary" type="button"
                                            (click)="selectCreate('activity')">Select</button>
                                    </div>
                                </div>
                                <br>

                                <div class="row">
                                    <div class="col-12 text-center">
                                        <!-- <button (click)="submit()" class="btn btn-primary">Submit</button> -->
                                        <button type="submit" class="btn btn-primary">Submit</button>
                                        <button type="button" class="btn btn-success d-none" type="reset" id="resetSub"
                                            #resetSub>Reset</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div id="tab-3" [hidden]="!update_flag">
                            <br>
                            <div class="col-12 text-right">

                                <button type="button" class="btn btn-primary" type="button" (click)="listfunc()">Back to
                                    list</button>
                            </div>
                            <br>
                            <form name="form" (ngSubmit)="f2.form.valid && update()" #f2="ngForm" novalidate>
                                <br>
                                <br>
                                <br>
                                <div class="row">
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-2 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            Firm Info:
                                        </h5>
                                    </div>
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">

                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Select Firm :</h6>
                                    </div>
                                    <div class="col-3">
                                        <ng-select [items]="all_party" bindLabel="org_name" bindValue="le_id"
                                            [multiple]="false" placeholder="Select Vender"
                                            [(ngModel)]="obj['party_le_id']" [selectableGroup]="true"
                                            [selectableGroupAsModel]="false" [closeOnSelect]="true"
                                            (click)="setPartyDetails()" name="party_le_id" #party_legal="ngModel"
                                            required>


                                            <!---------------- validation start-----------------------------  -->

                                            <!-- border color green -->
                                            <div [class.selection-box]="party_legal.dirty && party_legal.valid">
                                            </div>

                                            <!-- error handling  -->
                                            <div *ngIf="f2.submitted && party_legal.invalid" class="error-message">
                                                <div *ngIf="party_legal.errors?.['required']">Please select firm
                                                </div>
                                            </div>

                                            <!---------------- validation end-----------------------------  -->
                                        </ng-select>
                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm GSTIN :</h6>
                                    </div>
                                    <div class="col-3">
                                        <input type="text" class="form-control" [(ngModel)]="obj['party_gstin_no']"
                                            name="gst" disabled>
                                    </div>
                                </div>
                                <br>
                                <div class="row">

                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm Email :</h6>
                                    </div>
                                    <div class="col-3">
                                        <input type="text" class="form-control" [(ngModel)]="obj['party_email']"
                                            name="email" disabled>

                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm Mobile Number :</h6>
                                    </div>
                                    <div class="col-3">
                                        <input type="number" class="form-control" [(ngModel)]="obj['party_phone_no']"
                                            name="mn" disabled>
                                    </div>
                                </div>
                                <br>
                                <br>
                                <div class="row">
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-2 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            Firm Info:
                                        </h5>
                                    </div>
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">File Number :</h6>
                                    </div>
                                    <div class="col-3">
                                        <input type="text" placeholder="enter file number"
                                            [(ngModel)]="obj['work_order_no']" class="form-control"
                                            name="work_order_num" #work_order_num="ngModel" required disabled>
                                        <!---------------- validation start-----------------------------  -->
                                        <!-- border color green -->
                                        <div [class.border_green]="work_order_num.dirty && work_order_num.valid">
                                            <!-- <div [class.border_green]="work_order_num.value && work_order_num.value.length > 0"> -->
                                        </div>

                                        <!-- error handling  -->
                                        <div *ngIf="f2.submitted && work_order_num.invalid" class="error-message">
                                            <div *ngIf="work_order_num.errors?.['required']">Please enter file number
                                            </div>
                                        </div>
                                        <!---------------- validation end-----------------------------  -->
                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">File Description :</h6>
                                    </div>
                                    <div class="col-3">
                                        <textarea style="width: 100%; height: 80px;" id="re" name="re"
                                            class="form-control" placeholder="Enter file description"
                                            [(ngModel)]="obj['work_desc']" name="desc" #desc="ngModel" required>
                                    </textarea>

                                        <!---------------- validation start-----------------------------  -->
                                        <!-- border color green -->
                                        <div [class.border_green]="desc.dirty && desc.valid">
                                        </div>

                                        <!-- error handling  -->
                                        <div *ngIf="f2.submitted && desc.invalid" class="error-message">
                                            <div *ngIf="desc.errors?.['required']">Please enter file description</div>
                                        </div>

                                        <!---------------- validation end-----------------------------  -->


                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Work Order Start Date :</h6>
                                    </div>
                                    <div class="col-3">
                                        <input type="date" [(ngModel)]="obj['work_start_dt']" class="form-control"
                                            name="work_start" #work_start="ngModel" required>

                                        <!---------------- validation start-----------------------------  -->

                                        <!-- border color green -->
                                        <div [class.border_green]="work_start.dirty && work_start.valid">
                                        </div>

                                        <!-- error handling  -->
                                        <div *ngIf="f2.submitted && work_start.invalid" class="error-message">
                                            <div *ngIf="work_start.errors?.['required']">Please enter work start date
                                            </div>
                                        </div>

                                        <!---------------- validation end-----------------------------  -->
                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Work Order End Date :</h6>
                                    </div>
                                    <div class="col-3">
                                        <input type="date" [(ngModel)]="obj['work_end_dt']" class="form-control"
                                            (change)="checkDate()" name="work_end" #work_end="ngModel">

                                        <div [class.border_green]="work_end.dirty && work_end.valid">
                                        </div>

                                        <div *ngIf="f2.submitted && work_end.invalid && work_start.value >= work_end.value"
                                            class="error-message">
                                            End date can't be before or the same as the start date.
                                        </div>
                                        <!-- <div *ngIf="f2.submitted && work_end.invalid" class="error-message">
                                            <div *ngIf="work_end.errors?.['required']">Please enter work end date </div>
                                        </div> -->


                                    </div>

                                </div>
                                <br>

                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%">File Amount (&#8377;): </h6>
                                    </div>
                                    <div class="col-3">
                                        <input type="text" class="form-control" [(ngModel)]="obj['work_order_amt']"
                                            class="form-control" placeholder="Enter file amount"
                                            oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                                            name="work_order_am" #work_order_am="ngModel" required>

                                        <!---------------- validation start-----------------------------  -->

                                        <!-- border color green -->
                                        <div [class.border_green]="work_order_am.dirty && work_order_am.valid">
                                        </div>

                                        <div *ngIf="work_order_am.value <= 0 " class="error-message">
                                            Please Amount Should Be Greater Than Zero
                                        </div>

                                        <div *ngIf="f2.submitted && work_order_am.invalid" class="error-message">
                                            <div *ngIf="work_order_am.errors?.['required']">Please enter file amount
                                            </div>
                                        </div>

                                        <!---------------- validation end-----------------------------  -->
                                    </div>
                                </div>


                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Upload Notesheet :</h6>
                                    </div>
                                    <div class="col-3">
                                        <input type="file" accept="application/pdf" class="form-control" name="pdf_1"
                                            #pdf1="ngModel" ngModel (change)="onChange($event,'WorkOrder_PDF1')">

                                        <a *ngIf="previous_pdf['pdf1']" (click)="viewDoc(0,'work_order_doc')"
                                            class="a-style">Previously uploaded:
                                            {{previous_pdf['pdf1']}}</a>
                                        <!---------------- validation start-----------------------------  -->

                                        <!-- border color green -->
                                        <div [class.border_green]="pdf1.dirty && pdf1.valid">
                                        </div>

                                        <!-- error handling  -->

                                        <!-- <div *ngIf="f2.submitted && pdf1.invalid" class="error-message">
                                            <div *ngIf="pdf1.errors?.['required']">Please upload work order PDF

                                            </div>
                                        </div> -->

                                        <!---------------- validation end-----------------------------  -->
                                    </div>


                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Upload Reference :</h6>
                                    </div>
                                    <div class="col-3">
                                        <input type="file" accept="application/pdf" class="form-control" name="pdf_2"
                                            #pdf2="ngModel" ngModel (change)="onChange($event,'WorkOrder_PDF2')">
                                        <a *ngIf="previous_pdf['pdf2']" (click)="viewDoc(0,'work_order_approval_doc')"
                                            class="a-style">Previously
                                            uploaded:
                                            {{previous_pdf['pdf2']}}</a>
                                        <!---------------- validation start-----------------------------  -->

                                        <!-- border color green -->
                                        <div [class.border_green]="pdf2.dirty && pdf2.valid">
                                        </div>

                                        <!-- error handling  -->

                                        <!-- <div *ngIf="f2.submitted && pdf2.invalid" class="error-message">
                                            <div *ngIf="pdf2.errors?.['required']">Please upload work order PDF

                                            </div>
                                        </div> -->

                                        <!---------------- validation end-----------------------------  -->
                                    </div>
                                </div>


                                <!-- <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Additional Document:</h6>
                                    </div>
                                    <div class="col-3">
                                        <input type="file"  accept="application/pdf"
                                            class="form-control" name="pdf_3" #pdf3="ngModel" ngModel
                                            (change)="onChange($event,'Additional_Doc')">

                                        <a *ngIf="obj['additional_doc']" (click)="viewDoc(0,'additional_doc')"
                                            class="a-style">Previously uploaded:
                                            {{previous_pdf['pdf3']}}</a>
                                            </div>

                                </div> -->

                                <div class="row">

                                    <div style="display: contents;"
                                        *ngFor="let item of additional_document;let i = index">
                                        <div class="col-3 mt-3">
                                            <h6 style="margin-left:2%">Additional Document: ({{i+1}})</h6>
                                        </div>
                                        <div class="col-3 mt-3">
                                            <div class="d-flex">
                                                <input type="file" accept="application/pdf" class="form-control"
                                                    (change)="onChangeAdditionalDoc($event,'Additional_Doc',i)">
                                                <b class="d-flex ml-1">
                                                    <i class="fa fa-plus text-success plus-icon-inside-style"
                                                        aria-hidden="true" (click)="addAdditionalDoc()"
                                                        *ngIf="i == additional_document.length-1"></i> &nbsp;&nbsp;

                                                    <i class="fa fa-trash trash-icon-style" aria-hidden="true"
                                                        (click)="removeAdditionalDoc(i)"
                                                        *ngIf="additional_document.length > 1 || i>1"></i>
                                                </b>
                                            </div>
                                            <a (click)="viewDoc(0,item)" *ngIf="item && !item.show_file_name_on_update"
                                                class="a-style">Previously uploaded:
                                                {{item}}</a>
                                        </div>
                                        <br>
                                    </div>

                                </div>


                                <br><br>
                                <div class="row">
                                    <div class="col-4">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-4 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            Budget-Project-Product-Activity Info:
                                        </h5>
                                    </div>
                                    <div class="col-4">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3"></div>
                                </div>
                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%">Select Budget:
                                        </h6>
                                    </div>
                                    <div class="col-3">
                                        {{budDesc[obj['bud_cd']]}}
                                        <div *ngIf="f2.submitted && !budDesc[obj['bud_cd']]" class="error-message">
                                            Please select budget hierarchy </div>


                                    </div>
                                    <div class="col-1">
                                        <button type="button" class="btn btn-primary"
                                            (click)="selectCreate('budget')">Select</button>
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Select Project:
                                        </h6>
                                    </div>
                                    <div class="col-3">
                                        {{projectObj[obj['proj_cd']]}}
                                        <div *ngIf="f2.submitted && !projectObj[obj['proj_cd']]" class="error-message">
                                            Please select project hierarchy </div>


                                    </div>
                                    <div class="col-1">
                                        <button type="button" class="btn btn-primary"
                                            (click)="selectCreate('project')">Select</button>
                                    </div>
                                </div>
                                <br>

                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Select Product :
                                        </h6>
                                    </div>
                                    <div class="col-3">
                                        {{productObj[obj['prod_cd']]}}

                                        <div *ngIf="f2.submitted && !productObj[obj['prod_cd']]" class="error-message">
                                            Please select product hierarchy </div>
                                    </div>
                                    <div class="col-1">
                                        <button type="button" class="btn btn-primary"
                                            (click)="selectCreate('product')">Select</button>
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Select Activity:
                                        </h6>
                                    </div>
                                    <div class="col-3">
                                        {{activityObj[obj['act_cd']]}}

                                        <div *ngIf="f2.submitted && !activityObj[obj['act_cd']]" class="error-message">
                                            Please select activity hierarchy </div>
                                    </div>
                                    <div class="col-1">
                                        <button type="button" class="btn btn-primary"
                                            (click)="selectCreate('activity')">Select</button>
                                    </div>
                                </div>
                                <br>
                                <br><br>

                                <div class="row">
                                    <div class="col-12 text-center">
                                        <!-- <button (click)="update()" class="btn btn-primary">Update</button> -->
                                        <button type="submit" class="btn btn-primary">Update</button>
                                        <button type="button" class="btn btn-success d-none" #resetUpdate
                                            type="reset">Rest</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div id="tab-4" [hidden]="!allWork_flage">
                            <br>
                            <div class="col-12 text-right">
                                <button type="button" class="btn btn-primary" (click)="listfunc()">Back to list</button>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-4">
                                    <mat-form-field style="margin-left: 2%">
                                        <input matInput (keyup)="applyFilter1($event.target)" placeholder="Filter">
                                    </mat-form-field>
                                </div>
                                <div class="col-4 text-center">
                                </div>

                            </div>

                            <div class=" example-container">
                                <!-- <table mat-table [dataSource]="datasourceWork" matSort #sortCol2="matSort">
                                    <ng-container matColumnDef="work_id">
                                        <th mat-header-cell *matHeaderCellDef class="left" mat-sort-header>ID

                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element; let i = index; "
                                            class="right">
                                            {{ element.work_id }}</td>
                                    </ng-container>


                                    <ng-container matColumnDef="work_no">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header> File
                                            Number

                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            {{ element.work_order_no }} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="work_desc">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header> File
                                            Description

                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            {{ element.work_desc }} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="party_le_id">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header> Firm name

                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            {{ element.party_legal_name }} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="start_dt">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header> Work Order
                                            Start
                                            Date

                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            {{ element.work_start_dt | date: 'dd/MM/yyyy'}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="end_dt">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header> Work Order
                                            End
                                            Date
                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            {{ element.work_end_dt | date: 'dd/MM/yyyy'}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="amt">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header> File
                                            Amount
                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            {{ element.work_order_amt }} </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="allWorkdisplayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: allWorkdisplayedColumns;">
                                    </tr>
                                </table>
                                <mat-paginator #paginator2 [pageSizeOptions]="[10, 20,50,100]" showFirstLastButtons>
                                </mat-paginator> -->

                                <table mat-table [dataSource]="datasourceWork" multiTemplateDataRows
                                    class="mat-elevation-z8">
                                    <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                                        <th mat-header-cell *matHeaderCellDef style="text-align: center"
                                            class="wrap-th">
                                            {{displayedColumnsObj[column]}} </th>
                                        <td mat-cell *matCellDef="let element" style="text-align: center;" class="wrap">
                                            <ng-container *ngIf="column === 'action'; else normalCell">
                                                <button type="button" class="btn btn-primary"
                                                    *ngIf="element.status == 'ACTIVE'" (click)="open_update(element)"
                                                    href="#tab-3" data-toggle="tab">Update</button>

                                                <button type="button" class="btn btn-info"
                                                    *ngIf="element.status == 'APPROVED' && is_loggedIn_role_is_FAO"
                                                    (click)="openAssignment(element)">Assign To</button>

                                                <button type="button" class="btn btn-success"
                                                    style="white-space: nowrap;"
                                                    *ngIf="apprflag &&element.status == 'ACTIVE'"
                                                    (click)="Appr(element)">Forward File</button>
                                                <button type="button" class="btn btn-info"
                                                    *ngIf="element.status == 'UNDERAPPROVAL' || element.status == 'APPROVED' || element.status == 'REJECTED'"
                                                    (click)="viewStatus(element)">Status</button>
                                                <button type="button" class="btn btn-danger"
                                                    *ngIf="element.status == 'ACTIVE'"
                                                    (click)="delete(element)">Delete</button>
                                                <button type="button" class="btn btn-primary"
                                                    (mouseenter)="targetMenuTrigger =createPlanmenuTrigger; mouseEnter(createPlanmenuTrigger)"
                                                    (mouseleave)="mouseLeave(createPlanmenuTrigger)"
                                                    style="white-space: nowrap;background: #7C2AC0 !important;color: white;"
                                                    #createPlanmenuTrigger="matMenuTrigger"
                                                    [matMenuTriggerFor]="createPlan">More</button>

                                                <mat-menu #createPlan="matMenu" [hasBackdrop]="false"
                                                    [overlapTrigger]="false">
                                                    <div (mouseenter)="mouseEnter(targetMenuTrigger)"
                                                        (mouseleave)="mouseLeave(targetMenuTrigger)">
                                                        <button mat-menu-item (click)="viewDeatils(element,0)">View Work
                                                            Details</button>
                                                        <button mat-menu-item
                                                            (click)="viewDoc(element,'work_order_doc')">Notesheet
                                                            Document</button>

                                                        <button mat-menu-item
                                                            (click)="viewDoc(element,'work_order_approval_doc')">Reference
                                                            Document</button>
                                                    </div>
                                                </mat-menu>
                                            </ng-container>
                                            <ng-template #normalCell>
                                                {{ element[column] }}
                                            </ng-template>
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"> </tr>
                                </table>

                            </div>


                        </div>
                        <div class="row" *ngIf="view_details">
                            <div class="col-12 text-right" style="margin-bottom: 10px;">
                                <button class="btn btn-primary" (click)="backToList()"> Back To List </button>

                            </div>

                            <fieldset class="comprision-fieldset">
                                <!-- <legend class="note-head p-1">File Info</legend> -->
                                <br>
                                <div class="row">
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-2 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            Firm Info:
                                        </h5>
                                    </div>
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">

                                    <div class="col-3">
                                        <h6 style="margin-left:2%">Selected firm :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['org_name']}}
                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm GSTIN :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['gst_no']}}
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm Email :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['email']}}

                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Firm Mobile Number :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['mobile_no']}}
                                    </div>
                                </div>
                                <br>
                                <br>
                                <div class="row">
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-2 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            File Info:
                                        </h5>
                                    </div>
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">File Number :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['work_order_no']}}
                                    </div>
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">File Description :</h6>
                                    </div>
                                    <div class="col-3 text-break">
                                        {{workDetailsObj['work_desc']}}

                                    </div>
                                </div>

                                <br>
                                <div class="row">
                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Work Order Start Date :</h6>
                                    </div>
                                    <div class="col-3">
                                        {{workDetailsObj['work_start_dt'] | date:'dd/MM/yyyy'}}
                                    </div>



                                    <div class="col-3 ">
                                        <h6 style="margin-left:2%">Work Order End Date :</h6>
                                    </div>
                                    <div class="col-3">
                                        <span *ngIf="workDetailsObj['work_end_dt']; else elseBlock;">
                                            {{workDetailsObj['work_end_dt'] | date:'dd/MM/yyyy'}}
                                        </span>
                                        <ng-template #elseBlock>
                                            N/A
                                        </ng-template>

                                    </div>

                                </div>
                                <br>
                                <div class="row">

                                    <div class="col-3">
                                        <h6 style="margin-left:2%">File Amount (&#8377;):</h6>
                                    </div>
                                    <div class="col-3">

                                        {{workDetailsObj['work_order_amt']}}

                                    </div>

                                </div>
                                <br>
                                <br>
                                <div class="row"
                                    *ngIf="workDetailsObj.additional_doc && workDetailsObj.additional_doc.length>0">
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-2 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            Additional Doc Info:
                                        </h5>
                                    </div>
                                    <div class="col-5">
                                        <hr class="hrline">
                                    </div>
                                    <!-- </div> -->
                                    <br>


                                    <!-- <div class="row" > -->

                                    <div style="display: contents;"
                                        *ngFor="let item of workDetailsObj.additional_doc;let i = index">
                                        <div class="col-3 mt-3">
                                            <h6 style="margin-left:2%">Additional Document: ({{i+1}})</h6>
                                        </div>
                                        <div class="col-3 mt-3">
                                            <a (click)="viewDoc(workDetailsObj,item)" class="a-style">
                                                {{item}}</a>
                                        </div>
                                    </div>
                                </div>
                                <br>

                                <div class="row">
                                    <div class="col-4">
                                        <hr class="hrline">
                                    </div>
                                    <div class="col-4 text-center">
                                        <h5 id="h" style="color: brown; min-height: 20px;">
                                            Project-Budget-Product-Activity Info:
                                        </h5>
                                    </div>
                                    <div class="col-4">
                                        <hr class="hrline">
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3"></div>
                                </div>
                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%">Selected Budget: </h6>
                                    </div>
                                    <div class="col-9">
                                        {{ workDetailsObj['budget']}}


                                    </div>

                                </div>
                                <br>

                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Selected Project: </h6>
                                    </div>
                                    <div class="col-9">
                                        {{ workDetailsObj['project']}}

                                    </div>

                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Selected Product:
                                        </h6>
                                    </div>
                                    <div class="col-9">
                                        {{ workDetailsObj['product']}}

                                    </div>

                                </div>

                                <br>

                                <div class="row">
                                    <div class="col-3">
                                        <h6 style="margin-left:2%"> Selected Activity:
                                        </h6>
                                    </div>
                                    <div class="col-9">
                                        {{ workDetailsObj['activity']}}
                                    </div>

                                </div>
                            </fieldset>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>

</div>



<div class="modal" id="selectCreate" data-backdrop="static">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title"> Select Event :</h4>
                <button type="button" class="close" (click)="closeModel()">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">

                <br>
                <div class="row">
                    <div class="col-3 text-center">


                    </div>
                    <div class="col-3 text-center"
                        style="background-color: #217dbb;color:white;padding-top: 8px;padding-bottom: 8px;">
                        <h6><b>Code</b></h6>


                    </div>
                    <div class="col-3 text-center"
                        style="background-color: #217dbb;color:white;padding-top: 8px;padding-bottom: 8px;">
                        <h6><b> Value</b></h6>
                    </div>


                </div>
                <br>
                <form name="form" (ngSubmit)="f3.form.valid && SubmitListHierforCreate()" #f3="ngForm" novalidate>
                    <div class="row">
                        <div class="col-3 text-right">
                            Level 1:
                        </div>
                        <div class="col-3">
                            <input type="text" class="form-control" [(ngModel)]="HierSelectObj['lvl1_cd']"
                                name="lvl1_cd" disabled>
                        </div>

                        <div class="col-3">
                            <ng-select [items]="level1" bindLabel="lvl1_value" bindValue="lvl1_cd"
                                (change)="onChangeLvl1()" [multiple]="false" placeholder="Select Level 1 "
                                [(ngModel)]="HierSelectObj['lvl1_cd']" [selectableGroup]="true"
                                [selectableGroupAsModel]="false" [closeOnSelect]="true" name="lvl1_value"
                                #lvl1_value="ngModel" required>
                            </ng-select>

                            <!---------------- validation start-----------------------------  -->

                            <!-- border color green -->
                            <div [class.border_green]="lvl1_value.dirty && lvl1_value.valid">
                            </div>

                            <!-- error handling  -->
                            <div *ngIf="f3.submitted && lvl1_value.invalid" class="error-message">
                                <div *ngIf="lvl1_value.errors?.['required']">*Root is required</div>
                            </div>

                            <!---------------- validation end-----------------------------  -->

                        </div>

                    </div>
                    <br>

                    <div class="row">
                        <div class="col-3 text-right">
                            Level 2 :
                        </div>
                        <div class="col-3">
                            <input type="text" class="form-control" [(ngModel)]="HierSelectObj['lvl2_cd']"
                                name="lvl2_cd" disabled>

                        </div>

                        <div class="col-3">
                            <ng-select [items]="level2" bindLabel="lvl2_value" bindValue="lvl2_cd"
                                (change)="onChangeLvl2()" [multiple]="false" placeholder="Select Level 2"
                                [(ngModel)]="HierSelectObj['lvl2_cd']" [selectableGroup]="true"
                                [selectableGroupAsModel]="false" [closeOnSelect]="true" name="lvl2_value">
                            </ng-select>
                        </div>


                    </div>
                    <br>

                    <div class="row">

                        <div class="col-3 text-right">
                            <h6> Level 3 :</h6>
                        </div>
                        <div class="col-3">
                            <input type="text" class="form-control" [(ngModel)]="HierSelectObj['lvl3_cd']"
                                name="lvl3_cd" disabled>
                        </div>

                        <div class="col-3">
                            <ng-select [items]="level3" bindLabel="lvl3_value" bindValue="lvl3_cd"
                                (change)="onChangeLvl3()" [multiple]="false" placeholder="Select Level 3"
                                [(ngModel)]="HierSelectObj['lvl3_cd']" [selectableGroup]="true"
                                [selectableGroupAsModel]="false" [closeOnSelect]="true" name="lvl3_value">
                            </ng-select>
                        </div>


                    </div>
                    <br>

                    <div class="row">

                        <div class="col-3 text-right">
                            <h6> Level 4 :</h6>
                        </div>
                        <div class="col-3">
                            <input type="text" class="form-control" [(ngModel)]="HierSelectObj['lvl4_cd']"
                                name="lvl4_cd" disabled>
                        </div>
                        <div class="col-3">
                            <ng-select [items]="level4" bindLabel="lvl4_value" bindValue="lvl4_cd"
                                (change)="onChangeLvl4()" [multiple]="false" placeholder="Select Level 4"
                                [(ngModel)]="HierSelectObj['lvl4_cd']" [selectableGroup]="true"
                                [selectableGroupAsModel]="false" [closeOnSelect]="true" name="lvl4_value">
                            </ng-select>
                        </div>
                    </div>
                    <br>

                    <div class="row">

                        <div class="col-3 text-right">
                            <h6> Level 5 :</h6>
                        </div>
                        <div class="col-3">
                            <input type="text" class="form-control" [(ngModel)]="HierSelectObj['lvl5_cd']"
                                name="lvl5_cd" disabled>
                        </div>

                        <div class="col-3">
                            <ng-select [items]="level5" bindLabel="lvl5_value" bindValue="lvl5_cd"
                                (change)="onChangeLvl5()" [multiple]="false" placeholder="Select Level 5"
                                [(ngModel)]="HierSelectObj['lvl5_cd']" [selectableGroup]="true"
                                [selectableGroupAsModel]="false" [closeOnSelect]="true" name="lvl5_value">
                            </ng-select>
                        </div>

                    </div>
                    <br>

                    <div class="row">

                        <div class="col-3 text-right">
                            <h6> Level 6 :</h6>
                        </div>
                        <div class="col-3">
                            <input type="text" class="form-control" [(ngModel)]="HierSelectObj['lvl6_cd']"
                                name="lvl6_cd" disabled>
                        </div>


                        <div class="col-3">
                            <ng-select [items]="level6" bindLabel="lvl6_value" bindValue="lvl6_cd"
                                (change)="onChangeLvl6()" [multiple]="false" placeholder="Select Level 6"
                                [(ngModel)]="HierSelectObj['lvl6_cd']" [selectableGroup]="true"
                                [selectableGroupAsModel]="false" [closeOnSelect]="true" name="lvl6_value">
                            </ng-select>
                        </div>

                    </div>
                    <br>

                    <div class="row">

                        <div class="col-3 text-right">
                            <h6> Level 7 :</h6>
                        </div>
                        <div class="col-3">
                            <input type="text" class="form-control" [(ngModel)]="HierSelectObj['lvl7_cd']"
                                name="lvl7_cd" [ngModelOptions]="{standalone: true}" disabled>
                        </div>

                        <div class="col-3">

                            <ng-select [items]="level7" (change)="onChangeLvl7()" bindLabel="lvl7_value"
                                bindValue="lvl7_cd" [multiple]="false" placeholder="Select Level 7"
                                [(ngModel)]="HierSelectObj['lvl7_cd']" [selectableGroup]="true"
                                [selectableGroupAsModel]="false" [closeOnSelect]="true" name="lvl7_value">
                            </ng-select>
                        </div>

                    </div>

                    <br>

                    <div class="row">

                        <div class="col-3 text-right">
                            <h6> Leaf :</h6>
                        </div>
                        <div class="col-3">
                            <input type="text" class="form-control" [(ngModel)]="HierSelectObj['leaf_cd']"
                                name="leaf_cd" disabled>
                        </div>
                        <div class="col-3">
                            <input type="text" class="form-control" [(ngModel)]="HierSelectObj['leaf_value']"
                                name="leaf_value" disabled>
                        </div>
                    </div>
                    <br>


                    <div class="row" *ngIf="leaf_msg">
                        <div class="col-11 text-center error-message">
                            Please select till leaf.
                        </div>
                        <br>
                    </div>

                    <div class="row">
                        <div class="col-12 text-center">
                            <!-- <button type="button" class="btn btn-primary" (click)="SubmitListHierforCreate()">Submit</button> -->
                            <button type="button" class="btn btn-primary" type="submit">Submit</button>
                            <button #hiereset type="button" class="btn btn-success d-none" type="reset"
                                id="hiereset">Reset</button>
                        </div>
                    </div>

                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" (click)="closeModel()">Close</button>
            </div>
        </div>
    </div>
</div>



<!-- WORKFLOW MODEL -->
<div class="modal" id="myModal3">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Approval</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <div class="row" *ngIf="ApprovalUserService.vendorflag==false">
                    <div class="col-4 text-right">
                        <h6>Select Forwarded To :</h6>
                    </div>
                    <div class="col-4">
                        <ng-select [items]="ApprovalUserService.workuser" bindLabel="desc" bindValue="user_id_appr"
                            [multiple]="false" placeholder="Select User" [(ngModel)]="forwarded_user_id"
                            [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="true"
                            name="work_order_id">
                        </ng-select>
                    </div>
                </div>
                <br>
                <!-- <div class="row">
                    <div class="col-4 text-right">
                        <h6>Remark :</h6>
                    </div>
                    <div class="col-4">
                        <textarea style="height: 10rem;width: 33rem;" [(ngModel)]="appr_remark"
                            placeholder="Enter Your Remark" class="form-control"></textarea>
                    </div>
                </div> -->
                <div class="notesheet">
                    <app-master-editor></app-master-editor>
                </div>
                <br>

                <div class="row" style="border: black;">
                    <div class="col-4 text-right">
                        <input type="checkbox" [(ngModel)]="message_flag" id="vehicle1" name="vehicle1" value="Bike">
                    </div>
                    <div class="col-4">
                        Notify Recipient
                    </div>
                </div>
                <br>
                <div class="row" *ngIf="ApprovalUserService.vendorflag==false">
                    <div class="col-12 text-center">
                        <button type="button" class="btn btn-primary" [disabled]="isResponseReceived"
                            (click)="Approvedapproval()">Submit
                        </button>
                    </div>
                </div>
                <br>

                <div *ngIf="ApprovalUserService.vendorflag==true" class="row">
                    <div class="col-12 text-center">
                        <button type="button" class="btn btn-primary" data-dismiss="modal"
                            (click)="Approvedapproval()">Send To
                            Vendor </button>
                    </div>
                </div>
                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>

            </div>
        </div>
    </div>
</div>
<!-- VIEW WORKFLOW STATUS -->

<div class="modal" id="myModal1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Status
                    <br>
                    <h6 *ngIf="statusArr.length>1">Document Number : {{statusArr[0]['doc_local_no']}}</h6>
                </h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <div class="modal-body">

                <div class="container">
                    <a *ngFor="let ob of statusArr;let i=index">
                        <!-- <h6>{{ob['status']}}</h6> -->
                        <div class="step completed" *ngIf="ob.status=='APPROVED'">
                            <div class="v-stepper">
                                <div class="circle"></div>
                                <div class="barblue" style="color: blue;margin-left: 40%;"
                                    *ngIf="i <statusArr.length-1"></div>
                            </div>

                            <div class="content">
                                {{statusArr.length- i}} - {{ob.role_cd}} - {{ob.user_name}} - {{ob.status}} - (
                                {{ob.timestamp}} )
                            </div>
                        </div>
                        <div class="step"
                            *ngIf="ob.status=='REJECTED' || ob.status=='REVOKED' || ob.status == 'SYSTEM REJECTED'">
                            <div class="v-stepper">
                                <div class="circles"></div>
                            </div>

                            <div class="content">
                                {{statusArr.length- i}} - {{ob.role_cd}} - {{ob.name}} - {{ob.status}} - (
                                {{ob.timestamp}} )
                            </div>
                        </div>
                        <!-- active -->
                        <div class="step" *ngIf="ob.status=='UNDERAPPROVAL'">
                            <div class="v-stepper">
                                <div class="circle"></div>
                                <div class="bar" style="color: black;margin-left: 40%;" *ngIf="i <statusArr.length-1">
                                </div>
                            </div>

                            <div class="content">
                                {{statusArr.length- i}} - {{ob.role_cd}} - {{ob.name}} - {{ob.status}} - (
                                {{ob.timestamp}} )
                                <!-- {{levelOfApproval[ob.level_of_approval]['designation_code']}} -
                                {{levelOfApproval[ob.level_of_approval]['section_code']}} -->
                            </div>
                        </div>
                        <div class="step" *ngIf="ob.status=='PENDING'">
                            <div class="v-stepper">
                                <div class="circle"></div>
                                <div class="bar" style="color: black;margin-left: 40%;" *ngIf="i <statusArr.length-1">
                                </div>
                            </div>

                            <div class="content">
                                {{statusArr.length- i}} - {{ob.role_cd}} - {{ob.name}} - {{ob.status}} - (
                                {{ob.timestamp}} )


                                <!-- {{levelOfApproval[ob.level_of_approval]['designation_code']}} -
                                {{levelOfApproval[ob.level_of_approval]['section_code']}} -->
                            </div>
                        </div>
                    </a>
                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">
                        <!-- Close -->Close
                    </button>
                    <!-- <button type="button" class="btn btn-success" data-dismiss="modal" (click)="certificate()">Download
                        Certificate </button> -->

                </div>

            </div>
        </div>
    </div>
</div>


<div class="modal" id="work_assign">
    <div class="modal-dialog modal-l">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title"> Assign File</h6>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <div class="modal-body">

                <div class="row">
                    <div class="col-4 text-right">
                        <h6>Select Employee : <span class="text-danger">*</span></h6>
                    </div>
                    <div class="col-6 text-left">
                        <ng-select [items]="parties" bindLabel="emp_name" bindValue="le_id" [multiple]="false"
                            placeholder="Select Employee" [(ngModel)]="assignmentObj['le_id']" [selectableGroup]="true"
                            [selectableGroupAsModel]="false" [closeOnSelect]="true" name="party_id_ass"
                            #party_id_ass="ngModel" required>


                            <!-- <div [class.selection-box]="party_id_ass.dirty && party_id_ass.valid">
                                </div>

                                <div *ngIf="assignForm.submitted && party_id_ass.invalid" class="error-message">
                                    <div *ngIf="party_id_ass.errors?.['required']">Please select Party
                                    </div>
                                </div> -->
                        </ng-select>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12 text-right">
                        <!-- <button type="button" class="btn btn-danger" data-dismiss="modal">
                                Close
                            </button> &nbsp;&nbsp;&nbsp;&nbsp; -->
                        <button type="submit" class="btn btn-primary" (click)="workAssignment()">
                            Assign
                        </button>
                    </div>
                </div>
                <!-- </form> -->
            </div>
        </div>
    </div>
</div>






<ngx-spinner>Loading....</ngx-spinner>